export const getChipColorBg = id => {
  return `var(--sinch-comp-chip-color-${id}-default-background-initial)`;
};
export const getChipColorFg = id => {
  return `var(--sinch-comp-chip-color-${id}-default-foreground-initial)`;
};